
import { authTokenKeyName, refreshTokenKeyName } from "src/utils/configs/authConfig";

type userDataProps = {
    mobile: string;
    name: string;
    userId: string;
    userName: string;
    userRole: string;
}
const useLocalStorageData = () => {
    const AuthToken = localStorage.getItem(authTokenKeyName)
    const refreshToken = localStorage.getItem(refreshTokenKeyName)
    let userDataLocal = localStorage.getItem("userData")
    const userType2 =   localStorage.getItem("userType")
    const userData: userDataProps = userDataLocal ? JSON.parse(userDataLocal) : null

    return { AuthToken, refreshToken, userData, userType:userType2 };
};

export default useLocalStorageData;
